import { useState } from "react";
import { setMuted as setSoundMuted, isMuted as isSoundMuted, tick } from "../lib/sounds";

/**
 * Floating mute toggle. Persists across pages via localStorage. Tagged with
 * `data-no-sound` so the global click listener doesn't beep when toggling.
 */
export function SoundToggle() {
  const [muted, setMuted] = useState<boolean>(isSoundMuted());

  function toggle() {
    const next = !muted;
    setSoundMuted(next);
    setMuted(next);
    if (!next) tick(); // give a confirmation blip when re-enabling
  }

  return (
    <button
      type="button"
      onClick={toggle}
      data-no-sound
      title={muted ? "Sound effects off — click to enable" : "Sound effects on — click to mute"}
      aria-label={muted ? "Enable sound effects" : "Mute sound effects"}
      className={`sound-toggle${muted ? " is-muted" : ""}`}
    >
      <span aria-hidden="true">{muted ? "🔇" : "🔊"}</span>
    </button>
  );
}
